import {
  Topic, Topics, TopicState, TopicsActionTypes,
  FETCH_TOPICS_SUCCEEDED,
  CREATE_TOPIC_SUCCEEDED, CREATE_TOPIC_FAILED,
  UPDATE_TOPIC_SUCCEEDED, UPDATE_TOPIC_FAILED,
  DELETE_TOPIC_SUCCEEDED, DELETE_TOPIC_FAILED,
  FETCH_SYNONYMS_SUCCEEDED,
  FETCH_ANTONYMS_SUCCEEDED,
  POLL_SYNCSTATUS_SUCCEEDED,
  TopicSyncState,
  TopicSyncRequestState,
  SYNC_TOPICS_SUCCEEDED,
  CREATE_SYNONYM_SUCCEEDED,
  CREATE_SYNONYM_FAILED,
  CREATE_ANTONYM_SUCCEEDED,
  CREATE_ANTONYM_FAILED,
  TermCreateState,
} from './types';

const initialTopics : Topics = new Array<Topic>() as Topics;
const initialState = new TopicState(initialTopics, null, null, null);

export function topicsReducer(
  state = initialState,
  action: TopicsActionTypes,
): TopicState {
  switch (action.type) {
    case FETCH_TOPICS_SUCCEEDED: {
      return {
        topics: action.topics,
        isSaveSuccess: null,
        isDeleteSuccess: null,
        createdTopicId: null,
      };
    }

    case CREATE_TOPIC_SUCCEEDED: {
      return {
        topics: state.topics.concat(action.topic),
        isSaveSuccess: true,
        isDeleteSuccess: null,
        createdTopicId: action.topic.topicId,
      };
    }

    case CREATE_TOPIC_FAILED: {
      return {
        topics: state.topics,
        isSaveSuccess: false,
        isDeleteSuccess: null,
        createdTopicId: null,
      };
    }

    case UPDATE_TOPIC_SUCCEEDED: {
      const topics = state.topics.map((item, _index) => {
        if (item.topicId !== action.topic.topicId) {
          return item;
        }
        return action.topic;
      });

      return {
        topics,
        isSaveSuccess: true,
        isDeleteSuccess: null,
        createdTopicId: null,
      };
    }

    case UPDATE_TOPIC_FAILED: {
      return {
        topics: state.topics,
        isSaveSuccess: false,
        isDeleteSuccess: null,
        createdTopicId: null,
      };
    }

    case DELETE_TOPIC_SUCCEEDED: {
      const topics = state.topics.filter((topic) => topic.topicId !== action.topicId);
      return {
        topics,
        isSaveSuccess: null,
        isDeleteSuccess: true,
        createdTopicId: null,
      };
    }

    case DELETE_TOPIC_FAILED: {
      return {
        topics: state.topics,
        isSaveSuccess: null,
        isDeleteSuccess: false,
        createdTopicId: null,
      };
    }

    default:
      return state;
  }
}

const initialSynonymState: string[] = new Array<string>();

export function synonymsReducer(
  state = initialSynonymState,
  action: TopicsActionTypes,
): string[] {
  switch (action.type) {
    case FETCH_SYNONYMS_SUCCEEDED: {
      return action.synonyms;
    }

    default:
      return state;
  }
}

const initialAntonymState: string[] = new Array<string>();

export function antonymsReducer(
  state = initialAntonymState,
  action: TopicsActionTypes,
): string[] {
  switch (action.type) {
    case FETCH_ANTONYMS_SUCCEEDED: {
      return action.antonyms;
    }

    default:
      return state;
  }
}

const initialTopicSyncState = new TopicSyncState(false, false);

export function topicSyncStateReducer(
  state = initialTopicSyncState,
  action: TopicsActionTypes,
): TopicSyncState {
  switch (action.type) {
    case POLL_SYNCSTATUS_SUCCEEDED: {
      return action.syncState;
    }

    default:
      return state;
  }
}

const initialTopicSyncRequestState = new TopicSyncRequestState(null, null);

export function topicSyncRequestReducer(
  state = initialTopicSyncRequestState,
  action: TopicsActionTypes,
): TopicSyncRequestState {
  switch (action.type) {
    case SYNC_TOPICS_SUCCEEDED: {
      return action.requestState;
    }

    default:
      return state;
  }
}

const initialCreateSynonymState = new TermCreateState(null, '');

export function createSynonymReducer(
  state = initialCreateSynonymState,
  action: TopicsActionTypes,
): TermCreateState {
  switch (action.type) {
    case CREATE_SYNONYM_SUCCEEDED: {
      return new TermCreateState(true, action.synonym);
    }

    case CREATE_SYNONYM_FAILED: {
      return new TermCreateState(false, '');
    }

    default:
      return new TermCreateState(null, '');
  }
}

const initialCreateAntonymState = new TermCreateState(null, '');

export function createAntonymReducer(
  state = initialCreateAntonymState,
  action: TopicsActionTypes,
): TermCreateState {
  switch (action.type) {
    case CREATE_ANTONYM_SUCCEEDED: {
      return new TermCreateState(true, action.antonym);
    }

    case CREATE_ANTONYM_FAILED: {
      return new TermCreateState(false, '');
    }

    default:
      return new TermCreateState(null, '');
  }
}
